import { HStack, VStack, Box } from '@hover/blueprint';
import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

const LogoListMobile: React.FC = () => (
  <VStack spacing={500} d={{ base: 'flex', tablet: 'none' }}>
    <HStack justifyContent="space-around" w="100%" alignItems="center">
      <Box pb={200}>
        <StaticImage
          quality={100}
          placeholder="blurred"
          src="../../../assets/images/state_farm_logo_1.png"
          alt="crawford-logo"
          height={24}
          width={175}
        />
      </Box>
      <StaticImage
        quality={100}
        height={100}
        placeholder="blurred"
        objectFit="contain"
        src="../../../assets/images/logo_nationWide.png"
        alt="gaf logo"
      />
    </HStack>
    <HStack mb={200} w="100%" alignItems="center" justifyContent="space-around">
      <StaticImage
        quality={100}
        placeholder="blurred"
        width={123}
        height={35}
        src="../../../assets/images/amfam_logo.png"
        alt="srs logo"
      />
      <StaticImage
        quality={100}
        placeholder="blurred"
        width={162}
        height={38}
        src="../../../assets/images/travelers_vector_logo_red.png"
        alt="travelers logo"
      />
    </HStack>
    <HStack
      pt={400}
      mb={200}
      w="100%"
      alignItems="center"
      justifyContent="space-around"
    >
      <StaticImage
        quality={100}
        placeholder="blurred"
        width={67}
        height={67}
        src="../../../assets/images/shelter-insurance.png"
        alt="owens corning logo"
      />
      <StaticImage
        quality={100}
        placeholder="blurred"
        width={134}
        height={59}
        src="../../../assets/images/cincinatti_logo.png"
        alt="bacon roofing supply logo"
      />
    </HStack>
  </VStack>
);

export default LogoListMobile;
